import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Replay = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement(SvgFill, {
    d: "M41.35 24.644C41.35 35.32 32.673 44 22 44 11.328 44 2.65 35.32 2.65 24.644c0-5.587 2.394-10.676 6.284-14.268.4-.299.998-.299 1.297.1.299.4.299.998 0 1.297-3.491 3.193-5.686 7.783-5.686 12.871 0 9.678 7.88 17.56 17.555 17.56s17.555-7.882 17.555-17.56c-.1-9.678-7.98-17.56-17.655-17.56h-.399l3.591 3.592c.4.399.4.898 0 1.297-.399.399-.898.399-1.297 0L18.71 6.785c-.2-.2-.3-.4-.3-.699 0-.3.1-.499.3-.598L23.895.299c.4-.399.898-.399 1.297 0 .4.4.4.898 0 1.297l-3.59 3.592H22c10.673.1 19.35 8.78 19.35 19.456Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M31 24.965c0 .212-.136.424-.34.566l-12.708 7.363a.493.493 0 0 1-.612 0c-.204-.142-.34-.354-.34-.567V17.673c0-.213.136-.425.34-.567a.493.493 0 0 1 .612 0L30.66 24.47c.203.07.34.283.34.496Z"
  })));
});
Replay.displayName = 'Replay';
Replay.defaultProps = {
  'aria-label': 'Replay'
};
export default Replay;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/Replay.js
// module id = 3265
// module chunks = 11